
import { Component, inject } from '@angular/core';
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Guid } from 'guid-typescript';
import { FranchiseModel } from 'src/app/models/franchise.model';
import { ToastService } from 'src/app/services/toast.service';
import { WorkloadsService } from 'src/app/services/workloads.service';

@Component({
    selector: 'app-franchise-modal',
    imports: [ReactiveFormsModule, MatInputModule, MatButtonModule, MatIconModule],
    templateUrl: './franchise-modal.component.html',
    styleUrls: ['./franchise-modal.component.scss']
})
export class FranchiseModalComponent {
  toastr = inject(ToastService);
  franchiseSvc = inject(WorkloadsService);
  dialogRef = inject<MatDialogRef<FranchiseModalComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);


  franchiseForm = this.getForm();

  ngOnInit() {
    if (this.data.action === 'edit') {
      this.franchiseForm.patchValue(this.data.franchiseData);
    }
  }

  onSubmit() {
    if (this.franchiseForm.valid) {
      let model = this.franchiseForm.value as FranchiseModel;
      model.phoneNumber = String(model.phoneNumber);
      if (model.id == Guid.createEmpty().toString()) {
        this.franchiseSvc.postFranchise(model).subscribe({
          next: (data) => {
            this.toastr.success(
              'Nueva Franquicia',
              'La nueva Franquicia se ha registrado correctamente.'
            );
            this.cleanForm();
          },
          error: (err) => {
            this.toastr.error('Error', 'Error al registrar la franquicia.');
          },
        });
      } else {
        this.franchiseSvc.updateFranchise(model.id, model).subscribe({
          next: (data) => {
            this.toastr.success(
              'Franquicia editada',
              'La Franquicia se ha editado correctamente.'
            );
            this.cleanForm();
          },
          error: (err) => {
            this.toastr.error('Error', 'Error al editar la franquicia.');
          },
        });
      }
    } else {
      this.franchiseForm.markAllAsTouched();
      this.toastr.error('Error', 'Revise el formulario.');
    }
  }

  cleanForm() {
    this.franchiseForm.reset();
    this.closeClick();
  }

  getForm(): UntypedFormGroup {
    return new UntypedFormGroup({
      id: new UntypedFormControl(Guid.EMPTY.toString()),
      name: new UntypedFormControl('', Validators.required),
      companyName: new UntypedFormControl('', Validators.required),
      address: new UntypedFormControl('', Validators.required),
      city: new UntypedFormControl('', Validators.required),
      phoneNumber: new UntypedFormControl('', [
        Validators.required,
        Validators.pattern('^[0-9]{10,}$'),
      ]),
      identificationNumber: new UntypedFormControl(null, [
        Validators.required,
        Validators.pattern('^[0-9]{10,}$'),
        Validators.minLength(11),
      ]),
      email: new UntypedFormControl('', [
        Validators.required,
        Validators.email,
      ]),
    });
  }

  validateOnlyNumbers(event: KeyboardEvent) {
    let key = event.key;
    if (['.', 'e', 'E', ',', '-', '+'].includes(key)) {
      event.preventDefault();
    }
  }

  closeClick() {
    this.dialogRef.close();
  }
}
